import { ApplicationConfig } from '../config/config';

enum KioskType {
  TEACH_PENDANT = 'teach_pendant',
}

const useIsKioskModeEnabled = () => {
  return ApplicationConfig.kiosk.enabled;
};

const useIsKioskTeachPendant = () => {
  return ApplicationConfig.kiosk.type === KioskType.TEACH_PENDANT;
};

export { KioskType, useIsKioskModeEnabled, useIsKioskTeachPendant };
